import { render, staticRenderFns } from "./STEP1.vue?vue&type=template&id=651e5d70&scoped=true&"
import script from "./STEP1.vue?vue&type=script&lang=js&"
export * from "./STEP1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e5d70",
  null
  
)

export default component.exports